var ctx = '/erp';
var clientId = 'erp-vue';
export default {
  ctx: ctx,
  clientId: clientId,  
  user:{
    account: {},
    get_access_token: function(){
      var sessionActive = sessionStorage.getItem("user.sessionActive"); //用于浏览器关闭后 再打开，要求重新登陆。
      if(sessionActive == null)
        localStorage.removeItem("user.accessToken");   
      var accessToken = localStorage.getItem("user.accessToken");      
      if(!accessToken)
        accessToken = null;//"eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsibXN1LXJlc291cmNlIl0sInVzZXJfbmFtZSI6ImFkbWluIiwic2NvcGUiOlsicmVhZCIsIndyaXRlIl0sImV4cCI6MTU0MjI5MDQ2MywiYXV0aG9yaXRpZXMiOlsiUk9MRV9VU0VSIiwiUk9MRV9VTklUWSJdLCJqdGkiOiI5ZDhhZmQ0My1mMjk2LTQwMjMtYWRmZS1hZDVjNzY3MGFhNTQiLCJjbGllbnRfaWQiOiJlcnAtdnVlIn0.gAk6d6A4UDh4ywvYyFBikRh8acRA_zzbc-FdKh5I2sFTVnB14VFXPGqC9opQ5vItFaA2pIGkb_fSMrEOQFEW_BUPrzMUj14_iI7zMTbEhRoMOLdTbSL4F73uSF6tWKuTvWVf1yVYP9LUQ2fy7b7WAx2-B9i78lTZAVPJWJAStWC-g2qhTt_PLAw9SnGi2LkmQGiBsmBsqK3UpHHWTZLvNS7fdAxwyNdCYv_lzoiwR7IBdnPXxHfLMCyuPmRHVe3Hqk2aPHO_TIVW-R2GY7cCxDO-g4P3B7ik_-exmDs76KNZEZMnyw4wZ-NELPOz8ZDHsmWKRQr6E51UcLmT-3pdrg";
      return accessToken;
    },
    set_access_token: function(accessToken){
      localStorage.setItem("user.accessToken", accessToken);
      sessionStorage.setItem("user.sessionActive", 1);
    },
    remove_access_token: function(){
      localStorage.removeItem("user.accessToken");
    },
    relogin: function(){
      var redirect_route_path = window.location.href;//window.vue.$route.path;
      var redirect_uri = window.location.pathname + "#/receiveAccessToken?redirectRoutePath=" + encodeURIComponent(redirect_route_path);  
      //重新登陆 oauth2
      window.location.href = 
        ctx + 
        "/oauth/authorize?client_id=" + 
        clientId + 
        "&response_type=token&redirect_uri=" + 
        encodeURIComponent(redirect_uri) + 
        "&scope=read&state=123456";         
    }
  },
  menu:{
    systems:[]
  },
  perm:{
    paths: null
  },
  enum:{
    enums: null
  },
  //提示，成功/失败
  tips: {
    loading: {
      showTimes: 0,
      fadeOut: true,
      show: false,
    },
    showLoading: function(){
      this.loading.showTimes ++;
      this.loading.fadeOut = false; 
      this.loading.show = true;            
    },
    hideLoading: function(){
      var that  = this;
      that.loading.showTimes --;
      if(this.loading.showTimes == 0){
        that.loading.fadeOut= true;
        setTimeout(()=>{
          that.loading.show = false;
        }, 150);        
      }         
    },
    hideAllLoading: function(){
      var that  = this;
      that.loading.showTimes = 0
      that.loading.fadeOut= true;
      if(1==1)
      setTimeout(()=>{
        that.loading.show = false;
      }, 150); 
    },
    successInfo: {
      show : false,
      title : "",
      message : "",
      timeout : {}
    },
    errorInfo: {
      show : false,
      title : "",
      message : "",
      timeout : {}
    },
    showSuccessInfo : function(title, message, duration){
      //如果有errorInfo,先把errorInfo隐藏掉
      this.errorInfo.show = false;
      var that = this;
      that.successInfo.title = title;
      that.successInfo.message = message;
      clearTimeout(that.successInfo.timeout);
      that.successInfo.show = true;      
      if(duration)        
        that.successInfo.timeout = setTimeout(function(){
          that.successInfo.show = false;
        }, duration);
      that.toTop();
    },
    showErrorInfo : function(title, message, duration){
      var that = this;
      that.errorInfo.title = title;
      that.errorInfo.message = message;
      clearTimeout(that.errorInfo.timeout);
      that.errorInfo.show = true;
      if(duration)        
        that.errorInfo.timeout = setTimeout(function(){
          that.errorInfo.show = false;
        }, duration);  
      that.toTop();    
    },
    toTop(){
      //document.body.scrollTop = 0;
      //document.documentElement.scrollTop = 0; 
      let distance = document.documentElement.scrollTop || document.body.scrollTop; //获得当前高度
      let step = distance/50; //每步的距离
      (function jump(){
        if(distance > 0){
          distance -= step;
          // document.documentElement.scrollTop = distance;
          // document.body.scrollTop = distance;
          window.scrollTo(0, distance);
          setTimeout(jump, 5)
        }
      })();
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js